import { axiosInstance } from "../axios";

export const kiemKhoApi = {
  getAll: async (params) => {
    return await axiosInstance.get("/inventory-check", { params });
  },
  checkStatus: async (params) => {
    return await axiosInstance.get(
      "/inventory-check/materials/stockCheckStatus",
      { params },
    );
  },
  create: async (body) => {
    return await axiosInstance.post("/inventory-check/create", body);
  },
  update: async (body) => {
    return await axiosInstance.post("/inventory-check/update", body);
  },
  export: (code) =>
    axiosInstance.get(`/inventory-check/${code}/export`, {
      responseType: "blob",
    }),
  approve: async ({ code, status }) => {
    const params = new URLSearchParams();

    params.append("code", code);
    params.append("status", status);

    return await axiosInstance.post("/inventory-check/approve", params);
  },
  exportMany: (codes) =>
    axiosInstance.post(`/inventory-check/bulk-export`, codes, {
      responseType: "blob",
    }),
};
